import { getEnv } from 'util/getEnv';
import { useGoogleMaps } from './load-maps-suspense.hooks';

const LoadMapsSuspense = ({ children }) => {
  useGoogleMaps({
    apiKey: getEnv('REACT_APP_GOOGLE_MAPS_API_KEY'),
    libraries: ['places'],
  });

  return children;
};

export default LoadMapsSuspense;
